// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"Video_videoContainer__3lUbj","mute":"Video_mute__2w4or"};